import {
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconWarningGray,
  IconZoneGray,
} from '@assets/images/icon';
import { IconTemp } from '@assets/images/main';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/logisticsAsset/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/manufacturingForklift/img/1.avif';
import image2 from '@src/assets/images/solution/manufacturingForklift/img/2.avif';
import image3 from '@src/assets/images/solution/manufacturingForklift/img/3.avif';
import image4 from '@src/assets/images/solution/manufacturingForklift/img/4.avif';
import image5 from '@src/assets/images/solution/manufacturingForklift/img/5.avif';
import image6 from '@src/assets/images/solution/manufacturingForklift/img/6.avif';

export default {
  type: 'Giải pháp Năng lượng/Môi trường',

  banner: {
    title: 'Hệ thống theo dõi vị trí xe nâng được tin dùng ngay cả trong nhà máy điện hạt nhân',
    desc: 'Sử dụng công nghệ định vị UWB để theo dõi di chuyển của xe nâng, tự động lưu trữ tuyến đường vận chuyển chất thải, đảm bảo tuân thủ quy định của cơ quan quản lý và tăng cường bảo mật tài sản.',
  },

  video: {
    title: 'Kết cấu kiên cố, tín hiệu yếu. ORBRO vượt qua giới hạn đó.',
    desc: 'Ngay cả trong không gian bị che phủ bằng tấm thép và trần cao trên 10 mét, công nghệ theo dõi vị trí của ORBRO vẫn thu nhận tín hiệu chính xác. Mọi dữ liệu về vị trí, thời gian di chuyển và người điều khiển tài sản trong nhà máy đều được lưu lại làm bằng chứng.',
    play: video,
  },

  func: [
    {
      theme: 'Theo dõi vị trí chính xác cao, liên tục trong môi trường khắc nghiệt',
      title: 'Thu thập dữ liệu vị trí ổn định ngay cả trong không gian kim loại kín',
      desc: 'Trong không gian kín được bao quanh bởi kết cấu kim loại, hệ thống theo dõi vị trí của ORBRO vẫn duy trì hiệu suất ổn định mà không bị mất tín hiệu. Cung cấp dữ liệu vị trí chính xác trong phạm vi ±30 cm ngay cả ở những nơi công nghệ TDoA thông thường không thể hoạt động.',
      sub1: 'Độ chính xác cao',
      icon1: IconRulerGray,
      sub2: 'Liên kết dữ liệu nhanh',
      icon2: IconShareGray,
      image: image1,
    },
    {
      title: 'Cài đặt được ngay cả với trần cao',
      desc: 'Dễ dàng nhận diện vị trí chính xác ngay cả ở không gian có trần cao trên 10 mét. Chỉ cần lắp đặt hạ tầng tối thiểu để bao phủ diện tích lớn, nâng cao hiệu quả lắp đặt và tiện lợi vận hành.',
      sub1: 'Chỉ định tài sản nguy hiểm',
      icon1: IconWarningGray,
      sub2: 'Cài đặt phương thức phản ứng',
      icon2: IconBellGray,
      image: image2,
    },
    {
      title: 'Thu nhận liên tục dù di chuyển nhanh hoặc tuyến phức tạp',
      desc: 'Ngay cả khi xe nâng di chuyển nhanh hoặc lặp lại đường chạy trong khu vực hẹp, mọi lộ trình đều được ghi lại chính xác mà không mất tín hiệu. Dữ liệu không bị gián đoạn ngay cả trong môi trường phản xạ trong nhà.',
      sub1: 'Độ chính xác cao',
      icon1: IconRulerGray,
      sub2: 'Liên kết dữ liệu nhanh',
      icon2: IconChainLinkGray,
      image: image3,
    },
    {
      theme: 'Tối ưu vận hành dựa trên thuật toán chính xác và lịch sử di chuyển',
      title: 'Ứng dụng thuật toán TDoA chính xác cao tiên tiến',
      desc: 'Thông qua 6 bước xử lý tinh chỉnh như đồng bộ thời gian, hiệu chỉnh sai số đồng hồ, tính toán vị trí bằng phương pháp bình phương tối thiểu, đảm bảo tính toán vị trí chính xác ngay cả trong môi trường phức tạp. Công nghệ độc quyền của ORBRO mang lại độ chính xác và ổn định tối ưu cho các nhà máy công nghiệp.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu trên đám mây',
      icon2: IconCloudCheckGray,
      image: image4,
    },
    {
      title: 'Lọc tín hiệu trong môi trường Multipath/NLOS',
      desc: 'Tự động loại bỏ dữ liệu bị méo do phản xạ tín hiệu hoặc điều kiện không nhìn thấy trực tiếp (NLOS), cung cấp vị trí chính xác dựa trên lộ trình thực tế. Đảm bảo tỷ lệ định vị thành công trên 98% ngay cả trong môi trường Multipath.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu trên đám mây',
      icon2: IconCloudCheckGray,
      image: image5,
    },
    {
      title: 'Quản lý dòng thời gian di chuyển của xe nâng',
      desc: 'Lộ trình di chuyển và thay đổi vị trí của xe nâng được lưu lại theo thứ tự thời gian, có thể phân tích thời gian dừng tại khu vực cụ thể hoặc phát hiện lệch tuyến.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu trên đám mây',
      icon2: IconCloudCheckGray,
      image: image6,
    },
  ],

  subfunc: {
    title: 'Chức năng đa dạng',
    desc: 'Quản lý chất thải y tế không được lơ là. Chỉ một sơ suất nhỏ cũng có thể dẫn đến tai nạn y tế nghiêm trọng. Do đó, cần quản lý cực kỳ chính xác và đảm bảo an toàn tuyệt đối.<br/>ORBRO cung cấp nhiều tính năng để xây dựng cơ sở y tế an toàn và hiệu quả.',

    data: [
      {
        icon: IconZoneGray,
        title: 'Theo dõi không gian kim loại',
        desc: 'Ổn định cả khu vực kín, cao.',
      },
      {
        icon: IconRulerGray,
        title: 'Định vị ATDoA chính xác',
        desc: 'Xe chạy nhanh ±50cm.',
      },
      {
        icon: IconChainLink,
        title: 'Hỗ trợ Multipath/NLOS',
        desc: 'Môi trường phức tạp vẫn chuẩn.',
      },
      {
        icon: IconDashboard,
        title: 'Hiển thị xe nâng',
        desc: 'Xem xe nâng trực tiếp.',
      },
      {
        icon: IconRoute,
        title: 'Lưu lịch sử lộ trình',
        desc: 'Lưu & xem timeline.',
      },
      {
        icon: IconBinocularsGray,
        title: 'Theo dõi liên tục',
        desc: 'Xe nhanh vẫn theo dõi mượt.',
      },
      {
        icon: IconChartRadius,
        title: 'Dữ liệu kiểm toán',
        desc: 'Dữ liệu dùng khi cần.',
      },
      {
        icon: IconWarning,
        title: 'Tự phát hiện ra/vào',
        desc: 'Khu vực quan trọng ghi tự động.',
      },
      {
        icon: IconBell,
        title: 'Cảnh báo dừng lâu',
        desc: 'Xe dừng quá lâu sẽ báo.',
      },
      {
        icon: IconRoute,
        title: 'Giám sát tránh va chạm',
        desc: 'Phân tích để tránh va.',
      },
    ],
  },

  system: {
    title: 'Cấu trúc hệ thống',
    img: rtlsSystem,
  },

  productTitle: 'Cấu hình sản phẩm',
  product: [{ tag: 'assetPackage' }, { tag: 'workerPackage' }],

  contents: [{ data: 'medicalPatient' }, { data: 'retailOffice' }, { data: 'blogMedical' }, { data: 'blogRTLS' }],
};
